import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import Button from '../../components/button/Button';
import { BUTTON_TYPE } from '../../components/button/constants';
import Drawer from '../../components/drawer/Drawer';
import { VEC_ICON_NAME } from '../../components/icons/constants';
import DrawerWithTitleAndFooter from '../../components/drawer/DrawerWithTitleAndFooter';
import PageBody from '../../components/pagebody/PageBody';
import StepperNavigation from '../../components/steppernavigation/StepperNavigation';
import TabbedNavigation from '../../components/tabbednavigation/TabbedNavigation';
import TabbedNavigationWithDefinedTitle from '../../components/tabbednavigation/TabbedNavigationWithDefinedTitle';
import styles from './ComponentDirectory.styles';
import Heading from '../../components/heading/Heading';
import { HEADING } from '../../components/heading/constants/constants';
import BasicCard from '../../components/card/basiccard/BasicCard';
import CardWBottomIcon from '../../components/card/CardWBottomIcon/CardWBottomIcon';
import CardWIconTitleAndButton from '../../components/card/CardWIconTitleAndButton/CardWIconTitleAndButton';
import IconLabel from '../../components/iconlabel/IconLabel';
import IconDropdown from '../../components/dropdown/icondropdown/IconDropdown';
import MultiSelectDropdown from '../../components/multiselect/multiselectdropdown/MultiSelectDropdown';
import Checkbox from '../../components/checkbox/basecheckbox/Checkbox';
import CheckboxWLabel from '../../components/checkbox/checkboxwlabel/CheckboxWLabel';
import TextInput from '../../components/input/textinput/TextInput';
import PasswordInput from '../../components/input/passwordinput/PasswordInput';
import SelectDropdown from '../../components/dropdown/selectdropdown/SelectDropdown';
import FormBoxesCard from '../../components/card/formboxescard/FormBoxesCard';
import MultiSelectDropdownWButton from '../../components/multiselect/multiselectdropdownwbuttons/MultiSelectDropdownWButtons';
import AddPayer from '../components/addpayernew/AddPayer';
import EditPayer from '../components/addpayernew/editpayer/EditPayer';
import AddRecipient from '../components/addrecipientnew/AddRecipient';
import EditRecipient from '../components/addrecipientnew/editrecipient/EditRecipient';
import Intermediary from '../components/intermediary/Intermediary';
import StepperDrawer from '../../components/stepperdrawer/StepperDrawer';
import FreeHandDraw from '../../components/input/freehanddraw/FreeHandDraw';
import useTxNavigate from '../../../libs/txnavigate/TxNavigateHook';

export default function ComponentDirectory() {
    const [formValues, setFormValues] = useState({
        username: "",
        password: "",
        phoneNumber: "",
        state: { label: "Option 1", value: "option 1" },

        companyName: "",
        phoneNumberOption: { label: "Option 1", value: "option 1" },
        landline: "",
    });

    const [isNecEditOpen, setIsNecEditOpen] = useState(false);

    const navigate = useTxNavigate();

    const onChangehandler = (event) => {
        const { name, value } = event.target;
        setFormValues((preVal) => ({ ...preVal, [name]: value }));
    };


    const [openDrawer, setOpenDrawer] = useState(false);
    const [openDrawerWrapper, setOpenDrawerWrapper] = useState(false);
    const [creditCardModalOpen, setCreditCardModalOpen] = useState(false)

    const [isChecked, setIsChecked] = useState(false);

    const tabList = [
        {
            title: <span style={{ display: "flex", alignItems: "center", }}><span style={{ fontWeight: "700", fontSize: "24px", marginRight: "6px" }}>10</span><span>In Progress</span></span>,
            tabBodyComponent: <p>Tabbed Body Component 1</p>,
            linkTo: "/tab1"
        }, {
            title: <span style={{ display: "flex", alignItems: "center", }}><span style={{ fontWeight: "700", fontSize: "24px", marginRight: "6px" }}>10</span><span>In Progress</span></span>,
            tabBodyComponent: <p>Tabbed Body Component 2</p>,
            linkTo: "/tab2"
        },
    ];

    const tabListWithTitleObj = [
        {
            title: {
                icon: VEC_ICON_NAME.PAYER_ICON,
                titleTextInBold: "10",
                titleText: "In Progress",
            },
            tabBodyComponent: <p>Tabbed Body Component 1</p>,
            linkTo: "/tab1"
        }, {
            title: {
                titleText: "Ready to submit",
            },
            tabBodyComponent: <p>Tabbed Body Component 2</p>,
            linkTo: "/tab2"
        }, {
            title: {
                titleText: "Ready to submit",
            },
            tabBodyComponent: <p>Tabbed Body Component 2</p>,
            linkTo: "/tab3"
        },
        {
            title: {
                titleText: "Ready to submit",
            },
            tabBodyComponent: <p>Tabbed Body Component 2</p>,
            linkTo: "/tab3"
        },
        {
            title: {
                titleText: "Ready to submit",
            },
            tabBodyComponent: <p>Tabbed Body Component 2</p>,
            linkTo: "/tab3"
        },
    ];

    /* For Stepper Navigation Component */
    const steps = [
        {
            title: "Domain",
            stepBodyComponent: <p>Step Body</p>,
            discardCb: () => { },
            backButtonText: "Back",
            prevCb: () => { },
            submitButtonText: "Next",
            submitCb: () => { },
        }, {
            title: "Sub Domain",
            stepBodyComponent: <p>Step Body</p>,
            discardCb: () => { },
            backButtonText: "Back",
            prevCb: () => { },
            submitButtonText: "Next",
            submitCb: () => { },
        }, {
            title: "DNS Set Up",
            stepBodyComponent: <p>Step Body</p>,
            discardCb: () => { },
            backButtonText: "Back",
            prevCb: () => { },
            submitButtonText: "Next",
            submitCb: () => { },
        }, {
            title: "DNS Set Up",
            stepBodyComponent: <p>Step Body</p>,
            backButtonText: "Back",
            prevCb: () => { },
            submitButtonText: "Next",
            submitCb: () => { },
        }, {
            title: "DNS Set Up",
            stepBodyComponent: <p>Step Body</p>,
            backButtonText: "Back",
            prevCb: () => { },
            submitButtonText: "Submit",
            submitCb: () => { },
        },
    ];

    const CREATE_NEW_DROPDOWN_ITEMS = [
        { itemName: "Forms", onClick: () => console.log('forms clicked') },
        { itemName: "Payers", onClick: () => console.log('payers clicked') },
        { itemName: "Recipients", onClick: () => { } },
        { isDivider: true },
        { itemName: "Users", onClick: () => { } },
        { itemName: "Notices", onClick: () => { } },
        { itemName: "Reports", onClick: () => { } },
    ];

    const MULTI_SELECT_FOOTER = (
        <div className='d-flex align-items-center justify-content-end' style={{ padding: "20px" }}>
            <Button style={{ width: "140px", height: "40px", marginRight: "16px" }} type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}>Reset</Button>
            <Button style={{ width: "140px", height: "40px" }} type={BUTTON_TYPE.PRIMARY}>Map Columns</Button>
        </div>
    );

    const NEC_GRID_PAYER_OBJECT = {
        "Id": "963000021",
        "Name": "Bulk GT Payer 1",
        "DisregardedEntity": "",
        "UserId": 1385,
        "FileType": "Business",
        "IdType": "EIN",
        "IdNumber": "963000021",
        "LastName": "Bulk GT Payer 1",
        "FirstName": "",
        "MiddleName": "",
        "Suffix": "",
        "Address1": "ikjhsgb ",
        "Address2": "",
        "City": "Asas",
        "State": "CA",
        "ZipCode": "90001",
        "Country": "US",
        "Email": "",
        "Stateid": "",
        "LastFilling": "false",
        "ClientPayerId": "",
        "Foreign": "false",
        "FederalState": "CA",
        "PhoneNumber": "98745689745",
        "Create_date": "2023-07-12T05:53:48.903",
        "IsActive": true,
        "GroupId": "",
        "UnMaskRecipientTin": false
    }

    const button1 = {
        style: { width: "140px", height: "40px", marginRight: "16px" },
        type: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
        children: "Reset",
        onClickCb: () => console.log('button 1 clicked'),
    }

    const button2 = {
        style: { width: "140px", height: "40px" },
        type: BUTTON_TYPE.PRIMARY,
        children: "Map Columns",
        onClickCb: () => console.log('button 2 clicked'),
    }

    const BILLING_ONE_STEPS = [
        {
            title: "Filing Fee Information",
            stepBodyComponent: <span>First component</span>,
            submitButtonText: "Next",
            backButtonDisable: false,
            submitButtonDisabled: false,
            submitButtonDisabledInfoCb: () => { },
            submitCb: () => { },
            prevCb: () => { },
        },
        {
            title: "Information 2",
            stepBodyComponent: <span>Second component</span>,
            backButtonText: "Back",
            submitButtonText: "Next",
            submitCb: () => { },
            prevCb: () => { },
        },
        {
            title: "Filing Fee 3",
            stepBodyComponent: <span>Third component</span>,
            backButtonText: "Back",
            submitButtonText: "Next",
            submitCb: () => { },
            prevCb: () => { },
        },
    ]

    const [isOpen, setIsOpen] = useState(false);
    const [isEditOpen, setIsEditOpen] = useState(false);

    const [isAddRecipientOpen, setIsAddRecipientOpen] = useState(false);
    const [isEditRecipientOpen, setIsEditRecipientOpen] = useState(false);

    const [isAddEditIntermediaryOpen, setIsAddEditIntermediaryOpen] = useState(false);

    const [openBilingForm, setOpenBilingForm] = useState(false)
    const [openStepperDrawer, setOpenStepperDrawer] = useState(false)
    return (
        <PageBody>
            <div style={styles.tempContainer}>
                <div style={styles.tempItem}>
                    <p> Currently being Used for Testing Common Components being used in the Application </p>
                    <p> Will be removed in Production</p>
                </div>
                <div>
                    <Heading type={HEADING.H1}>Currently being Used for Testing Common Components being used in the Application </Heading>
                </div>

                <div>
                    <Heading type={HEADING.H2}>Currently being Used for Testing Common Components being used in the Application </Heading>
                </div>

                <div>
                    <Heading>Currently being Used for Testing Common Components being used in the Application </Heading>
                </div>

                <div>
                    <Heading>Stepper Drawer Component</Heading>
                    <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => setOpenStepperDrawer(!openStepperDrawer)}>Open Stepper Drawer</Button>

                    <StepperDrawer isOpen={openStepperDrawer} steps={BILLING_ONE_STEPS} onCloseCb={() => setOpenStepperDrawer(!openStepperDrawer)} />
                </div>

                <div style={styles.tempItem}>
                    <h2>Drawer</h2>
                    <button onClick={() => setOpenDrawer(!openDrawer)}>toggle drawer</button>
                    <Drawer isOpen={openDrawer} onCloseCb={() => setOpenDrawer(false)} >
                        <p>Drawer Body</p>
                    </Drawer>
                    <button onClick={() => setOpenDrawerWrapper(!openDrawerWrapper)}>toggle drawer wrapper</button>

                    <DrawerWithTitleAndFooter
                        isOpen={openDrawerWrapper}
                        onCloseCb={() => setOpenDrawerWrapper(false)}
                        title={"Add funds to Your Prepay wallet"}
                        backButtonProp={{
                            backCb: () => { },
                            text: "Back",
                        }}
                        submitButtonProp={{
                            submitCb: () => { },
                            text: "Next",
                        }}
                    >
                        <p>Body</p>
                    </DrawerWithTitleAndFooter>
                </div>

                <div style={styles.tempItem}>
                    <div style={{ width: "120px" }}>
                        <Button type={BUTTON_TYPE.PRIMARY}>Primary</Button>
                    </div>

                    <div style={{ width: "120px" }}>
                        <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}>Discard</Button>
                    </div>
                    <div style={{ width: "340px" }}>
                        <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}>Primary Light WIth Border</Button>
                    </div>
                </div>
                <div style={styles.tempItem}>
                    <h2>Tabbed Navigation</h2>
                    <h5>Tabbed Navigation with respective URL. Add "/tab2" in address bar</h5>
                    <Routes>
                        {
                            tabList.map((item, idx) => {
                                return (
                                    <Route exact path={`${item.linkTo}`} element={
                                        <TabbedNavigation tabList={tabList} useSeparateUrl={true} parentPath={"/componentdirectory"} activeTabIndex={idx} />
                                    } />
                                )
                            })
                        }
                    </Routes>

                    <h5>Tabbed Navigation with no respective URL</h5>
                    <TabbedNavigation tabList={tabList} />


                    <h5>Tabbed Navigation using Defined Title Structure as per UX</h5>
                    <div style={{ width: "100%" }}><TabbedNavigationWithDefinedTitle tabListWithTitleObj={tabListWithTitleObj} /></div>
                </div>
                <div style={styles.tempItem}>
                    <h2>Stepper Navigation</h2>
                    <StepperNavigation steps={steps} />
                </div>
                <div>
                    <div style={{ width: "100%" }}><TabbedNavigationWithDefinedTitle tabListWithTitleObj={tabListWithTitleObj} /></div>
                </div>

                <div className="d-flex justify-content-around w-100">
                    <CardWIconTitleAndButton
                        title="Individual"
                        icon={VEC_ICON_NAME.UPLOAD_FROM_COMPUTER}
                        isHighlighted
                        alignItems="center"
                        justifyContent="center"
                    />
                    <CardWIconTitleAndButton
                        title="Individual"
                        icon={VEC_ICON_NAME.UPLOAD_FROM_COMPUTER}
                        alignItems="center"
                        justifyContent="center"
                    />
                    <CardWIconTitleAndButton
                        title="Upload from your computer"
                        icon={VEC_ICON_NAME.UPLOAD_FROM_COMPUTER}
                        subText={"Use our easy to use template to quickly add multiple payers"}
                        linkButtonText={"Download our template"}
                        alignItems="center"
                        justifyContent="center"
                    />
                </div>

                <div className="w-50">
                    <BasicCard isHighlighted fullWidth>
                        <p className="m-0">Assigning Brad to all 3 users works!</p>
                    </BasicCard>
                    <br />
                    <BasicCard>
                        <p className="m-0">No, I want to change this</p>
                    </BasicCard>
                </div>

                <div>
                    <CardWBottomIcon
                        title="Create form?"
                        icon={VEC_ICON_NAME.UPLOAD_FROM_COMPUTER}
                        subText={"Get started with eFiling 1099 forms easily."}
                        linkButtonText={"Create Form"}
                    />
                </div>
                <div className='d-flex w-25 justify-content-between'>
                    <IconLabel text="$5000.00" icon={VEC_ICON_NAME.WALLET_ICON} />
                    <IconLabel text="Need Help?" icon={VEC_ICON_NAME.INFO_ICON} />
                </div>

                <div className='mt-4'>
                    <IconDropdown label="Create New" iconName={VEC_ICON_NAME.CIRCULAR_CHECKBOX} dropdownItems={CREATE_NEW_DROPDOWN_ITEMS} />
                </div>

                <div className='mt-5 w-50'>
                    <MultiSelectDropdown options={[
                        { label: "Account payable", value: "1", checked: false },
                        { label: "Legal fees", value: "2", checked: false },
                        { label: "Payroll service fees", value: "3", checked: false },
                        { label: "Rent", value: "4", checked: false },
                    ]}
                        searchFieldPlaceholder="Search by name"
                        FooterComponent={MULTI_SELECT_FOOTER} />
                </div>

                <div className='mt-5 w-50'>
                    <MultiSelectDropdownWButton options={[
                        { label: "Account payable", value: "1", checked: false },
                        { label: "Legal fees", value: "2", checked: false },
                        { label: "Payroll service fees", value: "3", checked: false },
                        { label: "Rent", value: "4", checked: false },
                    ]}
                        searchFieldPlaceholder="Search by name"
                        buttonProps={[button1, button2]}
                    />
                </div>

                <div className="mt-2">
                    <div className="mt-2">
                        <CheckboxWLabel label="Fishing boat proceeds" checked={isChecked} onChangeCb={() => setIsChecked(prev => !prev)} />
                    </div>
                </div>

                <div className='mt-5 w-25'>
                    <TextInput
                        name="username"
                        type="email"
                        placeHolder='Enter email'
                        onChangeCb={onChangehandler}
                        prefixProps={{ icon: VEC_ICON_NAME.EMAIL_ICON }}
                    />

                    <div className='mb-4'></div>

                    <PasswordInput name="password" type="password" placeHolder='Password' onChangeCb={onChangehandler} />

                    <div className='mb-5'></div>

                    <TextInput
                        label="Contact Number"
                        type="number"
                        placeHolder="Contact Number"
                        name="phoneNumber"
                        value={formValues.phoneNumber}
                        onChangeCb={onChangehandler}
                    />
                </div>

                <div className='mt-5'>
                    <SelectDropdown
                        name="state"
                        placeHolder="Enter state"
                        value={formValues.state}
                        onSelectCb={(name, selectedOption) => setFormValues(prev => ({ ...prev, [name]: selectedOption }))}
                        options={[{ label: "Option 1", value: "option 1" }, { label: "Option 2", value: "option 2" },
                        { label: "Option 3", value: "option 3" }, { label: "Option 4", value: "option 4" }]}
                    />
                </div>

                <div className='mt-5'>

                    <div className='row w-100 align-items-end'>
                        <div className='col-12 mb-5'>
                            <TextInput
                                label="Company Name"
                                type="text"
                                placeHolder="Company Name"
                                name="companyName"
                                value={formValues.companyName}
                                onChangeCb={onChangehandler}
                            />
                        </div>
                        <div className='col-4'>
                            <SelectDropdown
                                label="Phone number"
                                name="phoneNumberOption"
                                value={formValues.phoneNumberOption}
                                onSelectCb={(name, selectedOption) => setFormValues(prev => ({ ...prev, [name]: selectedOption }))}
                                prefixProps={{ text: "+1" }}
                                options={[{ label: "Option 1", value: "option 1" }, { label: "Option 2", value: "option 2" },
                                { label: "Option 3", value: "option 3" }, { label: "Option 4", value: "option 4" }]}
                            />
                        </div>
                        <div className='col-8'>
                            <TextInput
                                type="text"
                                placeHolder="(201) 555-0123"
                                name="landline"
                                value={formValues.landline}
                                onChangeCb={onChangehandler}
                            />
                        </div>
                    </div>
                </div>

                <div className='mt-5'>
                    <Heading type={HEADING.H1}>Add/Edit Payer/Recipient</Heading>
                    <Button onClickCb={() => setIsOpen(true)}>Add Payer</Button>

                    <Button style={{ marginTop: "20px" }} onClickCb={() => setIsEditOpen(true)}>Edit Payer</Button>

                    <Button style={{ marginTop: "20px" }} onClickCb={() => setIsAddRecipientOpen(true)}>Add recipient</Button>

                    <Button style={{ marginTop: "20px" }} onClickCb={() => setIsEditRecipientOpen(true)}>Edit recipient</Button>


                    {isOpen && <AddPayer isPopup isPopupOpen={isOpen} onPopupCloseCb={() => setIsOpen(false)} />}
                    {isEditOpen && <EditPayer payerID={2505} isPopup isPopupOpen={isEditOpen} onPopupCloseCb={() => setIsEditOpen(false)} />}

                    {isAddRecipientOpen && <AddRecipient isPopup isPopupOpen={isAddRecipientOpen} onPopupCloseCb={() => setIsAddRecipientOpen(false)} />}
                    {isEditRecipientOpen && <EditRecipient recipientID={8936496} isPopup isPopupOpen={isEditRecipientOpen} onPopupCloseCb={() => setIsEditRecipientOpen(false)} />}
                </div>

                <div className='mt-5'>
                    <Heading type={HEADING.H1}>NEC GRID: Add/Edit Payer/Recipient</Heading>

                    <Button style={{ marginTop: "20px" }} onClickCb={() => setIsNecEditOpen(true)}>Edit Payer</Button>

                    {isNecEditOpen &&
                        <EditPayer
                            fromNecGrid={true}
                            submitFormCb={(data) => { console.log(data) }}
                            payerData={NEC_GRID_PAYER_OBJECT}
                            isPopup
                            isPopupOpen={isNecEditOpen}
                            onPopupCloseCb={() => setIsNecEditOpen(false)}
                        />
                    }

                </div>

                <div>
                    <div className='mt-5'>
                        <Heading type={HEADING.H1}>Add/Edit Intermediary</Heading>
                        <Button style={{ marginTop: "20px" }} onClickCb={() => setIsAddEditIntermediaryOpen(true)}>Add/Edit Intermediary</Button>
                        {isAddEditIntermediaryOpen && <Intermediary isPopup={true} isPopupOpen={isAddEditIntermediaryOpen} onPopupCloseCb={() => setIsAddEditIntermediaryOpen(false)} />}
                    </div>

                    <div className='mt-5'>
                        <Button onClickCb={() => navigate(`/forms/listing?FormId=47&TaxYear=2022&PayerId=147666&FormType=Regular`)}>Go To Form Listing</Button>
                    </div>

                </div>
                <div className='mt-5'>
                    <Heading type={HEADING.H1}>Free Hand Draw component for signature</Heading>
                    <FreeHandDraw />

                </div>
            </div>
        </PageBody>
    )
}